<template>
  <div class="contact-lang">
    <p @click="contactPanelHandler" class="contact">Kontakt</p>
    <p>
      <a href="/en">English</a>
    </p>
  </div>
</template>

<script>
import { bus } from "../main";

export default {
  name: "ContactBtn",
  methods: {
    contactPanelHandler: function() {
      bus.$emit("contactPanelHandler");
    }
  }
};
</script>

<style lang="scss">
.contact-lang {
  position: fixed;
  top: $screen-gutter-top;
  right: $screen-gutter-right;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 160px;
  z-index: 30;
  cursor: pointer;

  p:hover {
    text-decoration: underline;
  }
}
</style>